/**
 * Created by Rami on 7/21/2016.
 */
(function(angular) {

    var TSToastService = function(scope) {

        var self = this;
        var toast;
        var timer;
        var callback;
        var button;

        self.showSuccess = function (text) {

            toast = $('#toast-container');

            button = $('<button class="close"></button>')
                        .attr('type', 'button')
                        .html('&times;')
                        .on('click', close);

            $('<div class="toast top toast-success"></div>')
                .append('<i class="fa fa-check-circle"></i>')
                .append($('<span class="content"></span>').html('&nbsp;' + text + '&nbsp;'))
                .append(button)
                .appendTo(toast);

            toast.stop().fadeIn(200);
            setTimeout(function () {
                scope.$digest();
            }, 0);

            timer = setTimeout(function () {
                close();
                scope.$digest();
            }, 5000);
        };

        self.showError = function (text, action, actionCallback) {

            toast = $('#toast-container');

            button = $('<button class="close"></button>')
                        .attr('type', 'button')
                        .html('&times;')
                        .on('click', close);

            var toastAlert = $('<div class="toast top toast-danger"></div>')
                                .append('<i class="fa fa-exclamation-triangle"></i>')
                                .append($('<span class="content"></span>').html('&nbsp;' + text + '&nbsp;'))
                                .append(button)
                                .appendTo(toast);

            if (action && actionCallback) {
                callback = $('<a class="callback" href="javascript:"></a>')
                                .text(action)
                                .css('display', 'inline')
                                .on('click', actionCallback);
                toastAlert.append(callback);
            }

            toast.stop().fadeIn(200);
            scope.$digest();
        };

        var close = function () {
            if (callback) {
                callback.off('click');
            }
            button.off('click');
            toast.stop().fadeOut(200, function () {
                clearTimeout(timer);
                toast.empty();
                scope.$digest();
            });
            scope.$digest();
        };

    };

    angular
        .module('harriApp')
        .service('TSToastService', [function () {
            return function (scope) {
                return new TSToastService(scope);
            }
        }]);

})(angular);
